export default __webpack_public_path__ + "static/media/farmer.471b6cff.png";